import { MinsterShowHideComponent } from "../ui-components/minster-show-hide/minster-show-hide.component";
import { MinsterCheckboxComponent } from "../ui-components/minster-checkbox/minster-checkbox.component";
import { MinsterSelectComponent } from "../ui-components/minster-select/minster-select.component";
import { ControlContainer, FormsModule, NgForm, NgModelGroup, Validators } from '@angular/forms';
import { MinsterInputComponent } from '../ui-components/minster-input/minster-input.component';
import { MinsterCardComponent } from "../ui-components/minster-card/minster-card.component";
import { LookUpServiceAndValidation } from '../../services/look-up-and-validation.service';
import { ClaimVehicle, ClaimVehicleRepair, VehicleHire } from '../../models/claim.model';
import { ScreenBaseComponent } from '../screen-base/screen-base.component';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { InputType, ScreenType } from '../../models/enums.models';
import { ClaimsService } from '../../services/claims.service';
import { StateService } from '../../services/state.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { LookUp } from '../../models/look-up.model';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
    selector: 'app-your-vehicle',
    standalone: true,
    imports: [MatCardModule, FormsModule, MinsterInputComponent, MinsterCardComponent, MinsterCheckboxComponent,
        MinsterShowHideComponent, MatButtonModule, MinsterSelectComponent, MatIconModule],
    templateUrl: './your-vehicle.component.html',
    styleUrl: './your-vehicle.component.css',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})

export class YourVehicleComponent extends ScreenBaseComponent {
    @ViewChild(NgModelGroup) _formGroup: NgModelGroup | undefined;
    _inputTypes = InputType;
    _readonly: boolean = false;
    _vehicle: ClaimVehicle;
    _vehicleRepair: ClaimVehicleRepair;
    _vehicleHire: VehicleHire;
    _repairHelpNotRequired: LookUp[];
    _whyHireNotNeeded: LookUp[];
    _showCompanyName: boolean = false;

    constructor(
        stateService: StateService,
        claimService: ClaimsService,
        router: Router,
        toastr: ToastrService,
        private change: ChangeDetectorRef,
        private lookUpService: LookUpServiceAndValidation
    ) {
        super(router, ScreenType.YourVehicle, toastr, stateService, claimService);
        this._readonly = stateService.formIsSubmitted;

        this._vehicle = stateService.claim?.claimVehicle!;
        this._vehicleRepair = stateService.claim!.claimVehicle.claimVehicleRepairs![0];
        this._vehicleHire = stateService.claim!.claimVehicle.vehicleHires![0];

        this._repairHelpNotRequired = stateService.lookUps!.lookUpDictionary['RepairHelpNotRequiredReasonsDigitalOnBoarding'];
        this._whyHireNotNeeded = stateService.lookUps!.lookUpDictionary['WhyHireNotNeededDigitalOnBoarding'];
    }

    override isScreenValid(): boolean {
        return this.stateService.getFormValidationErrorsExcludeRequired(this._formGroup!.control) == 0;
    }

    onHireNotNeededChanged(reasonId: number | null): void {
        this._showCompanyName = reasonId === 6;
    }

    onLookUpRegistration(vrm: string): void {
        this.lookUpService.getVehicleDetails(vrm).subscribe({
            next: (result) => {
                const claimVehicle = this.stateService.claim?.claimVehicle;

                if (claimVehicle) {
                    claimVehicle.vehicleMake = result.make;
                    claimVehicle.vehicleModel = result.model;
                    claimVehicle.vehicleColour = result.colour;
                }

                this.change.markForCheck();
            },
            error: (ex) => {
                this.toastr.error('There was an error fetching the vehicle data, Please try again' + ex.toString());
            },
        });
    }

    override onNext(): void {
         if(this._readonly){
            super.onNext();
            return;
        }
        this.updateValidators();

        if (this._formGroup && this._formGroup.invalid) {
            let hasErrors = false;

            Object.keys(this._formGroup.control.controls).forEach((key) => {
                const control = this._formGroup!.control.get(key);

                if (control) {
                    const errors = control.errors;

                    if (errors) {
                        const hasOnlyRequiredError = Object.keys(errors).length === 1 && errors['required'];

                        if (this.stateService.formIsSubmitted) {
                            hasErrors = true;
                        }
                        else if (!hasOnlyRequiredError) {
                            hasErrors = true;
                        }
                    }

                    control.markAsTouched();
                    control.markAsDirty();
                    control.updateValueAndValidity();
                }
            });

            if (hasErrors) {
                this.toastr.warning('Please fix the form errors before proceeding.');
                this.stateService.enableSaving = false;
                return;
            }
        }

        if (this.stateService.formIsSubmitted && this._formGroup!.invalid) {
            this.toastr.warning('Please fix the required fields before proceeding.');
            this.stateService.enableSaving = false;
            return;
        }

        this.stateService.enableSaving = this.hasStateChanged(); 
        
        super.onNext();
    }

    get isVehicleOwner(): boolean {
        return this.stateService.claim?.isVehicleOwner || false;
    }

    updateValidators(): void {
        const controls = [
            { formName: this._fcn.YourVehicle.RepairHelpNotRequiredReason, makeRequired: this._vehicleRepair.isRepairHelpRequired === false, resetValue: undefined },
            { formName: this._fcn.YourVehicle.TemporaryReplacementVehicleNeededReason, makeRequired: this._vehicleHire.isTemporaryReplacementVehicleNeeded === false, resetValue: undefined }
        ];

        controls.forEach(({ formName, makeRequired, resetValue }) => {
            const control = this._formGroup?.control.get(formName);

            if (control) {
                if (makeRequired) {
                    control.setValidators([Validators.required]);
                } 
                else {
                    control.clearValidators();
                    control.setValue(resetValue);
                }

                control.updateValueAndValidity();
            }
        });
    }
}